import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import { TextSecondary } from "~components/shared/todo-lib-react-components/text"

function Ellipsis() {
    const styles = useStyles()

    return <TextSecondary style={styles.root}>...</TextSecondary>
}

function useStyles() {
    return componentStyles({
        root: {
            marginX: 2,
            transform: "translateY(-3px)",
        },
    })
}

export default Ellipsis
